import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { QA_ROLES,ADMIN_ROLES} from "../constant";

const Home = () => {
  const role = useSelector((state) => state.auth.role);
  const token = useSelector((state) => state.auth.token);

  if (!token) return <Navigate to="/login" />;

  if (ADMIN_ROLES.includes(role)) return <Navigate to="/admin-dashboard" />;
  if (QA_ROLES.includes(role)) return <Navigate to="/qa-dashboard" />;

  return <Navigate to="/unauthorized" />;
};

export default Home;
